export default __webpack_public_path__ + "static/media/Doc111111.3b9d8b0f.pdf";